import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=db66eaa2&scoped=true"
import script from "./EvaluationList.vue?vue&type=script&lang=js"
export * from "./EvaluationList.vue?vue&type=script&lang=js"
import style0 from "./EvaluationList.vue?vue&type=style&index=0&id=db66eaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db66eaa2",
  null
  
)

export default component.exports